import axios from "axios";
import { toast } from "react-toastify";

// get lat and lan of source
export const getLatLongSourceAction = async (placeid) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/places/placesDetailsSource?place_id=${placeid}`
  );

  return response;
};

// get lat and lan of destination
export const getLatLongDestinationAction = async (placeid) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/places/placesDetailsDestination?place_id=${placeid}`
  );

  return response;
};

// get time details of source or destination
export const getTimeDetailsAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/places/placeTimezone?lat=${payload?.lat}&lng=${payload?.lng}`
  );

  return response;
};

export const getMatchingRegionsAction = async (region) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/getMatchingRegion?lat=${region.lat}&lng=${region.lng}`
    );

    //
    return response;
  } catch (error) {}
};

export const getDistanceBetweenSourceAndDestinationAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/places/checkDistance?origin=${payload?.sourcelatlng}&destination=${payload?.destlatlng}`
    );

    return response;
  } catch (error) {}
};

export const searchVehiclesAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/vehicles/showVehicleWithPrice?date=${payload.date}&km=${payload.km}&userId=${payload.userId}&time=${payload.time}&sourceLatLng=${payload.sourceLatLng}&destinationLatLng=${payload.destinationLatLng}&currency=${payload.currency}`
    );

    return response;
  } catch (error) {}
};

export const searchVehiclesHourlyPriceAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/vehicles/showVehicleWithPriceHourly?sourcePLaceId=${payload.sourceplaceid}&distance=${payload.distance}&hour=${payload.hour}&date=${payload.date}&userId=${payload.userId}&time=${payload.time}&currency=${payload.currency}`
    );

    return response;
  } catch (error) {}
};

export const searchVehicleWithPriceFlateRateAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/vehicles/showVehicleFlateRate?sourceLatLng=${payload.sourceLatLng}&destinationLatLng=${payload.destinationLatLng}&km=${payload.km}&userId=${payload.userId}&date=${payload.date}&time=${payload.time}&currency=${payload.currency}`
    );

    return response;
  } catch (error) {}
};

export const bookingInitiateWithVehicleAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bookings/bookingWithVechile`,
      payload
    );

    return response;
  } catch (error) {}
};

export const boookingPaymentAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/bookings/bookingPayment`,
    payload.body
  );

  return response;
};

export const confirmBookingWithPassengerDetailAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/passengers/passengerCreateAndBooking`,
      payload
    );

    return response;
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const getBookingDetailsAction = async (payload) => {
  try {
    let response;
    if (payload.search) {
      response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/bookings/getAllBooking?${
          payload.search.bookingId && `bookingId=${payload.search.bookingId}`
        }&${
          payload.search.createdDateEnd &&
          payload.search.createdDateEnd &&
          `createdDateStart=${payload.search.createdDateStart}&createdDateEnd=${payload.search.createdDateEnd}`
        }&${
          payload.search.travelStartDate &&
          payload.search.travelEndDate &&
          `travelStartDate=${payload.search.travelStartDate}&travelEndDate=${payload.search.travelEndDate}`
        }&${payload.search.userName && `userName=${payload.search.userName}`}&${
          payload.search.bookingStatus &&
          `bookingStatus=${payload.search.bookingStatus}`
        }&${
          payload.search.paymentStatus &&
          `paymentStatus=${payload.search.paymentStatus}`
        }&${
          payload.search.affiliateName &&
          `affiliateName=${payload.search.affiliateName}`
        }&${
          payload.search.companyName &&
          `companyName=${payload.search.companyName}`
        }&${
          payload.search.passengerName &&
          `passengerName=${payload.search.passengerName}`
        }&${payload.search.quoteby && `quoteby=${payload.search.quoteby}`}
         `,
        {
          headers: {
            Authorization: payload.token,
          },
        }
      );
    } else {
      response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/bookings/getAllBooking?page=${payload.pageCount}`,
        {
          headers: {
            Authorization: payload.token,
          },
        }
      );
    }

    return response.data;
  } catch (error) {}
};

export const getAllBookingWithoutSearchAction = async (payload) => {
  try {
    let response;
    response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/getAllBookingV2?page=${payload?.pageCount}&viewBookingPermisision=${payload?.viewBookingPermisision}&companyId=${payload?.companyId}&userRole=${payload.userRole}&userName=${payload.userName}`
      // {
      //   headers: {
      //     Authorization: payload.token,
      //   },
      // }
    );
    return response;
  } catch (error) {}
};

export const getAllBookingWithSearchAction = async (payload) => {
  try {
    let response;
    if (payload.search) {
      response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/bookings/bookingWithsearch?page=${
          payload?.pageCount
        }&viewBookingPermisision=${payload?.viewBookingPermisision}&companyId=${
          payload?.companyId
        }&userRole=${payload.userRole}&userName=${payload?.userName}${`${
          payload.search.bookingId
            ? `&bookingId=${payload.search.bookingId}`
            : ""
        }${
          payload.search.userName
            ? `&userNameQuery=${payload.search.userName}`
            : ""
        }${
          payload.search.bookingStatus
            ? `&bookingStatus=${payload.search.bookingStatus}`
            : ""
        }${
          payload.search.paymentStatus
            ? `&paymentStatus=${payload.search.paymentStatus}`
            : ""
        }${
          payload.search.affiliateName
            ? `&affiliateName=${payload.search.affiliateName}`
            : ""
        }${
          payload.search.companyName
            ? `&companyName=${payload.search.companyName}`
            : ""
        }${
          payload.search.passengerName
            ? `&customerName=${payload.search.passengerName}`
            : ""
        }${payload.search.DateType ? `&DateType=${payload.DateType}` : ""}${
          payload.search.createdDateStart
            ? `&createdDateStart=${payload.search.createdDateStart}`
            : ""
        }${
          payload.search.createdDateEnd
            ? `&createdDateEnd=${payload.search.createdDateEnd}`
            : ""
        }${
          payload.search.travelStartDate
            ? `&travelStartDate=${payload.search.travelStartDate}`
            : ""
        }${
          payload.search.travelEndDate
            ? `&travelEndDate=${payload.search.travelEndDate}`
            : ""
        }${
          payload.search.passengerNumber
            ? `&passengerNumber=${payload.search.passengerNumber}`
            : ""
        }${
          payload.search.invoiceNumber
            ? `&invoiceNumber=${payload.search.invoiceNumber}`
            : ""
        }${
          payload.search.invoicedStatus
            ? `&invoicedStatus=${payload.search.invoicedStatus}`
            : ""
        }${
          payload.search.affiliateNumber
            ? `&affiliateNumber=${payload.search.affiliateNumber}`
            : ""
        }${
          payload.search.driverName
            ? `&driverName=${payload.search.driverName}`
            : ""
        }${
          payload.search.driverNumber
            ? `&driverNumber=${payload.search.driverNumber}`
            : ""
        }${payload.search.groupId ? `&groupId=${payload.search.groupId}` : ""}${
          payload.search.quoteby ? `&quoteby=${payload.search.quoteby}` : ""
        }`}`
      );
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getBookingDetailsByIdAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings?id=${payload?.id}`
    );

    return response.data.bookingDetails;
  } catch (error) {}
};

// TODO: airport database add
// get air port db
export const getAirPortDbAction = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/airports`
    );

    return response.data;
  } catch (error) {}
};

// update booking

export const updateBookingAction = async (payload) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/bookings/updateBooking`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
        onUploadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        },
      }
    );

    return response;
  } catch (error) {}
};

// check source is in region
export const checkSourceIsInRegionAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/vehicles/sourceMatchingRegion?sourcePLaceId=${payload.sourcePLaceId}`
    );

    return response;
  } catch (error) {}
};

// check destination is in region
export const checkDestinationIsInRegionAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/vehicles/destinationMatchingRegion?destPLaceId=${payload.destPLaceId}`
    );

    return response;
  } catch (error) {}
};

export const totalBokingAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/totalBooking`,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response.data;
  } catch (error) {}
};

// cuurency layer api
export const getCurrencyLayerApiAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/currencyLayer?from=${payload.from}&to=${payload.to}&amount=${payload.amount}`
    );

    return response.data;
  } catch (error) {}
};

export const flightApiAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/getFlightData?flightNumber=${payload?.flightNumberIata}&year=${payload?.year}&month=${payload?.month}&date=${payload?.date}`
    );

    return response.data;
  } catch (error) {}
};

export const flightArrivalDateApiAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/bookings/getArrivalFlightData?flightNumber=${payload?.flightNumberIata}&year=${payload?.year}&month=${payload?.month}&date=${payload?.date}`
  );

  return response.data;
};

export const flightDepartureDateApiAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/bookings/getDepartureFlightData?flightNumber=${payload?.flightNumberIata}&year=${payload?.year}&month=${payload?.month}&date=${payload?.date}`
  );

  return response.data;
};

// send invoice
export const sendInvoiceAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bookings/invoiceMail`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },

        withCredentials: true,
      }
    );

    return response;
  } catch (error) {}
};

// send voucher
export const sendVoucherAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bookings/voucherMail`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const sendCancelBookingVoucherAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bookings/affiliateCancelVoucher`,
      payload.affiliateVoucherData,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const sendVoucherb2cAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bookings/voucherMailB2c`,
      payload.body
    );

    return response;
  } catch (error) {}
};

export const sendAffiliateVoucherAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bookings/affiliateVoucher`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const driverDetailMailAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bookings/driverdeatailMail`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const passengerDetailsUpdateAction = async (payload) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/passengers/passengerUpdate?passengerId=${payload.passengerId}`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const bookingHistoryCreateAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bookings/bookingHistoryCreate?id=${payload.bookingId}`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const jobsForTodayAction = async (payload) => {
  try {
    // const response = await axios.get(
    //   `${process.env.REACT_APP_BASE_URL}/bookings/jobsfortoday`,
    //   {
    //     headers: {
    //       Authorization: payload.token,
    //     },
    //   }
    // );

    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/jobsfortoday?userRole=${payload?.userRole}&page=${payload?.page}&checkPendingPay=${payload?.checkPendingPay}`
    );
    console.log(response.data);
    // return response.data;
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const jobsForTomorrowAction = async (payload) => {
  try {
    // const response = await axios.get(
    //   `${process.env.REACT_APP_BASE_URL}/bookings/jobsfortomorrow`,
    //   {
    //     headers: {
    //       Authorization: payload.token,
    //     },
    //   }
    // );

    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/jobsfortomorrow?userRole=${payload?.userRole}&page=${payload?.page}&checkPendingPay=${payload?.checkPendingPay}`
    );

    // return response.data;
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const unassignedJobsAction = async (payload) => {
  try {
    // const response = await axios.get(
    //   `${process.env.REACT_APP_BASE_URL}/bookings/unassignedJobs`,
    //   {
    //     headers: {
    //       Authorization: payload.token,
    //     },
    //   }
    // );

    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/unassignedJobs?userRole=${payload?.userRole}&page=${payload?.page}`
    );
    // return response.data;
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const getVehicleUnitPriceAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/vehicles/vehicleUnitPrice?vehicleWithPricevalue=${payload.vehicleWithPricevalue}&currency=${payload.currency}`
    );

    return response;
  } catch (error) {}
};

export const sendWatiMsgAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/bookings/sendMessageWithWati?bookingId=${payload.bookingId}`
  );

  return response;
};

export const createDuplicateBookingAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/bookings/createduplicateBooking`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};
export const createMultipleDuplicateBookingAction = async (payload) => {
  console.log("createMultipleDuplicateBookingAction ====>",payload)
  const params = {
    bookingId:payload?.bookingId,
    passengerId:payload?.passengerId,
    firstDate:payload?.firstDate,
    lastDate:payload?.lastDate,
    newCloneTime:payload?.travelTime,
    userName:payload?.userName,
  }

  const bodyPayload = {
    companyLogo:payload?.companyLogo,
    companyAddress:payload?.companyAddress,
    companyEmail:payload?.companyEmail,
    company_name:payload?.company_name,
  }
  console.log("params ====>",params)
  console.log("bodyPayload ====>",bodyPayload)

  if(payload?.groupName && payload?.groupOption){
    bodyPayload.isGroupBooking =true
    bodyPayload.GroupId = payload?.groupName
  }


  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/bookings/createMultipleDuplicateBooking`,
    bodyPayload,
    {
      headers: {
        Authorization: payload.token,
      },
      params: params
    },
    
  );

  return response;
};

export const getTrackingDetailAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/bookings/trackingDetail?generatedBookingId=${payload.bookingId}`
  );

  return response;
};

export const getISTConvertedTimeAction = async (payload) => {
  //
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/places/getISTConvertedTime?travellDateTime=${payload?.travellDateTime}&IndianTimezone=${payload?.IndianTimezone}&travellTimeZone=${payload?.travellTimeZone}`
    );

    return response;
  } catch (error) {}
};

export const createGroupBookingAction = async (payload) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/bookings/createGroupBooking`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const getGroupIdsAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/groupBookingIDs`,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const groupInBookingsAction = async (payload) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/bookings/groupInBookings?groupId=${payload.groupId}`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const groupOutBookingsAction = async (payload) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/bookings/groupOutBookings`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const addInvoiceToGroupedBookingAction = async (payload) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/bookings/addinvoiceToGroup`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const changeBookingStatusToPobAction = async (payload) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/bookings/POBStatusBookings?bookingId=${payload.bookingId}`,

      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const bookinginProgressForPOBAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/bookings/POBStatusBookings`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const deleteCreditCardsFromBookingAction = async (payload) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/bookings/deleteCreditCardsFromBooking?bookingId=${payload.bookingId}`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {}
};

export const affiliatePaymentStatusAction = async (payload) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/bookings/affiliatePaymentStatus`,
      payload.body,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const ammendmentCheckedAction = async (payload) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/bookings/AmmendmentChecked?ammendmentId=${payload?.ammendmentId}&email=${payload?.email}`,
      {},
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getAllFinAmmendmentAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/getAllFinAmmendments`,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getAllFinUncheckedAmmendmentCountAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/countNumOfFinUncheckedAmmendments`,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getAllOpsAmmendmentAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/getAllOpsAmmendments`,

      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getAllOpsUncheckedAmmendmentCountAction = async (payload) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/bookings/countNumOfOpsUncheckedAmmendments`,

      {
        headers: {
          Authorization: payload.token,
        },
      }
    );

    return response;
  } catch (error) {
    return error;
  }
};
